<template>
    <div class="record-typerelease">
    <PageTitle icon="fa fa-clone" :main="typerelease.name_type_release" 
        sub="Complememnto do Tipo de Lançamento"/>
    <b-card no-bg-variant="light" text-variant="dark" no-body 
    >
    <b-tabs card pills vertical small>
    <b-tab title="Retenção" active>
        <b-row>
            <b-col md="10" sm="12">
                <b-button 
                    size="sm" 
                    v-b-modal.modalRetention  
                    variant="dark" 
                    class="mb-2 fa fa-plus" 
                > </b-button>
            <transition  name="slide" type="animation" appear> 
                <b-table 
                    class="table-responsive" 
                    hover 
                    key="slide" 
                        head-variant="light" 
                    :items="typereleasesretentions" 
                    :fields="fieldsRetention"> 
                    <template v-slot:cell(actions)="data">
                        <b-button 
                            title = "Editar registro" 
                            v-b-modal.modalRetention  
                            size="sm" 
                            variant="light" 
                            @click="loadTypeReleasesRetention(data.item)" 
                            class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="light" 
                            @click="modeRetention = 'remove'" 
                            class="mr-2 mt-2"
                            v-if="modeRetention === 'insert'"
                        >
                        <i class="fa fa-trash"></i>
                        </b-button>
                        <b-button 
                                
                            size="sm" 
                            variant="light" 
                            @click="[RemoveRetention(data.item),modeRetention = 'insert']" 
                            class="mr-2 mt-2"
                            v-if="modeRetention === 'remove'"
                        >
                            <i class="fa fa-check"></i>
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="light" 
                            @click="modeRetention = 'insert'" 
                            class="mr-2 mt-2"
                            v-if="modeRetention === 'remove'"
                        >
                            <i class="fa fa-times"></i>
                        </b-button>
                        <span class="mr-2 mt-2"  v-if="modeRetention === 'remove'" > Deseja Excluir o registro? </span>
                    </template>
                </b-table>
            </transition>
            </b-col>
        </b-row>
    </b-tab>
        <b-tab title="Imposto" >
            <b-row>
                <b-col md="10" sm="12">
                <b-button 
                    size="sm" 
                    v-b-modal.modalTax  
                    variant="outline-success" 
                    class="mb-2" 
                > <i class="fa fa-plus"></i></b-button>
                <transition  
                        name="slide" 
                        type="animation" 
                        appear> 
                    <b-table 
                        class="table-responsive" 
                        hover 
                        key="slide" 
                        sticky-header 
                        head-variant="light"  
                        :items="typereleasestaxs" 
                        :fields="fieldsTax"> 
                        <template v-slot:cell(actions)="data">
                            <b-button 
                                title = "Editar registro" 
                                v-b-modal.modalTax  
                                size="sm" 
                                variant="light" 
                                @click="loadTypeReleasesTax(data.item)" 
                                class="mr-2 mt-2 fa fa-pencil">
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="light" 
                                @click="modeTax = 'remove'" 
                                class="mr-2 mt-2 fa fa-trash"
                                v-if="modeTax === 'insert'"
                            >
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="light" 
                                @click="[RemoveTax(data.item),modeTax = 'insert']" 
                                class="mr-2 mt-2 fa fa-check"
                                v-if="modeTax === 'remove'"
                            >
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="light" 
                                @click="modeTax = 'insert'" 
                                class="mr-2 mt-2 fa fa-times"
                                v-if="modeTax === 'remove'"
                            >
                            </b-button>
                            <span 
                                class="mr-2 mt-2"  
                                v-if="modeTax === 'remove'" > 
                                Deseja Excluir o registro? 
                            </span>
                        </template>
                    </b-table>
                </transition>
                </b-col>
            </b-row>
        </b-tab>
        <b-tab title="Item" >
            <b-row>
                <b-col md="10" sm="12">
                <b-button 
                    size="sm" 
                    v-b-modal.modalItem 
                    @click="alterModoItem" 
                    variant="dark" 
                    class="mb-2 fa fa-plus" 
                > </b-button>
                <transition  
                        name="slide" 
                        type="animation" 
                        appear> 
                    <b-table 
                            class="table-responsive" 
                            hover key="slide"  
                            head-variant="light"
                            sticky-header 
                            :items="typereleasesitems" 
                            :fields="fieldsItem"> 
                        <template v-slot:cell(actions)="data">
                            <b-button 
                                title ="Editar registro" 
                                v-b-modal.modalItem  
                                size="sm" 
                                variant="light" 
                                @click="loadTypeReleasesItem(data.item)" 
                                class="mr-2 mt-2 fa fa-pencil">
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="light" 
                                @click="modeItem = 'remove'" 
                                class="mr-2 mt-2 fa fa-trash"
                                v-if="modeItem === 'insert'"
                            >
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="light" 
                                @click="[RemoveItem(data.item),modeItem = 'insert']" 
                                class="mr-2 mt-2 fa fa-check"
                                v-if="modeItem === 'remove'"
                            >
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="light" 
                                @click="modeItem = 'insert'" 
                                class="mr-2 mt-2 fa fa-times"
                                v-if="modeItem === 'remove'"
                            >
                            </b-button>
                            <span class="mr-2 mt-2"  v-if="modeItem === 'remove'" > Deseja Excluir o registro? </span>
                        </template>
                    </b-table>
                </transition>
                </b-col>
            </b-row>
        </b-tab>
        <b-tab title="Classificação" >
        <b-row>
            <b-col md="10" sm="12">
                <b-button 
                    size="sm" 
                    v-b-modal.modalTypeRleaseCompany  
                    variant="dark" 
                    @click="[setAppointment()]"
                    class="mb-2 fa fa-plus" 
                > 
                </b-button>
                <transition  
                        name="slide" 
                        type="animation" 
                        appear> 
                <b-table 
                        class="table-responsive" 
                        hover 
                        key="slide" 
                        head-variant="light"
                        sticky-header  
                        :items="typereleasesapportionments" 
                        :fields="fieldsCompany"> 
                    <template v-slot:cell(actions)="data">
                        <b-button 
                            title = "Editar registro" 
                            v-b-modal.modalTypeRleaseCompany  
                            size="sm" 
                            variant="light" 
                            @click="loadTypeReleasesApportionment(data.item)" 
                            class="mr-2 mt-2 fa fa-pencil">
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="light" 
                            @click="modeCompany = 'remove'" 
                            class="mr-2 mt-2 fa fa-trash"
                            v-if="modeCompany === 'insert'"
                        >
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="success" 
                            @click="[RemoveCompany(data.item),modeCompany = 'insert']" 
                            class="mr-2 mt-2 fa fa-check"
                            v-if="modeCompany === 'remove'"
                        >
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="danger" 
                            @click="modeCompany = 'insert'" 
                            class="mr-2 mt-2 fa fa-times"
                            v-if="modeCompany === 'remove'"
                        >
                        </b-button>
                        <span 
                            class="mr-2 mt-2"  
                            v-if="modeCompany === 'remove'" > 
                            Deseja Excluir o registro? 
                        </span>
                    </template>
                </b-table>
                </transition>
            </b-col>
        </b-row>
        </b-tab>
        </b-tabs>
           
          </b-card>
          <b-row>
               <b-col md="8" sm="12">
               <b-button 
                    size="lq" 
                    btn-sm 
                    variant="dark" 
                    title="Retornar tela de consulta"
                    class="ml-2 mt-2 fa fa-reply" 
                    @click="goback">
                </b-button> 
               </b-col> 
          </b-row>

            <b-modal id="modalRetention"
            ref="modal"
            title="Retenção"
            title-tag = "h6"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveRetention"
            >
                <b-form>
                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group 
                                label="Retenção:" 
                                label-for="typereleasesretention-retention_id">
                            <b-form-select 
                                id="typereleasesretention-retention_id"
                                size="sm"
                                :options="retentions" 
                                v-model="typereleasesretention.retention_id" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">    
                            <b-form-group 
                                label="%:" 
                                label-for="typereleasesretention-percent">
                                <b-form-input 
                                    id="typereleasesretention-percent" 
                                    v-model="typereleasesretention.percent" 
                                    type="number"
                                    size="sm"
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>

            <b-modal id="modalTax"
            ref="modal"
            title="Imposto"
            title-tag = "h6"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveTax"
            >
                <b-form>
                    <b-row>
                         <b-col md="8" sm="12">
                            <b-form-group 
                                label="Imposto:" 
                                label-for="typereleasestax-tax_id">
                            <b-form-select 
                                id="typereleasestax-tax_id"
                                size="sm"
                                :options="taxs" 
                                v-model="typereleasestax.tax_id" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">    
                            <b-form-group label="%:" label-for="typereleasestax-percent">
                                <b-form-input id="typereleasestax-percent" 
                                    v-model="typereleasestax.percent" 
                                    type="number"
                                    size="sm"
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>

            <b-modal id="modalItem"
            ref="modal"
            title="Item"
            title-tag = "h6"
            size="lg"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveItem"
            >
                <b-form>
                    <b-row>
                        <b-col md="2" sm="2">
                            <b-form-group label="Item:" label-for="item-id">
                            <b-form-input id="item-id" type="text"
                                v-model="typereleasesitem.item_id"
                                @input="loadItem"
                                size="sm"
                                placeholder="Código..." />
                            </b-form-group>
                        </b-col>    
                        <b-col md="8" sm="8">
                            <b-form-group label="Descrição:" label-for="item-name">
                            <b-form-input 
                                id="item-name" 
                                type="text"
                                v-model="item.complements_name"
                                size="sm"
                                :readonly= 'true'
                                placeholder="Descrição..." />
                            </b-form-group>
                        </b-col> 
                         <b-col md="2" sm="2">
                            <b-form-group 
                                label="Unid:" 
                                label-for="item-initials">
                            <b-form-input 
                                id="item-initials" 
                                type="text"
                                v-model="item.initials"
                                size="sm"
                                :readonly= 'true'
                                placeholder="Unid." />
                            </b-form-group>
                        </b-col>   
                    </b-row>
                </b-form>
                      <hr>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <label class="control-label"> Pesquisar os Items </label> <b-button  size="sm" class=" ml-2 mb-2 fa" :class="icon" @click="[loadtItems(), showTable = !showTable]" variant="outline-secondary" ></b-button>
                            <input type="text" size="sm" icon="search" v-model="search" placeholder="Informe o nome" class="form-control">
                        </div>
                    </div>
                     <hr>
                    <transition  name="slide" type="animation" appear>       
                    <b-table class="table-responsive"  v-show="showTable" hover key="slide" striped :items="filteredList" :fields="fieldsRecordItem">
                        <template slot="actions" slot-scope="data">
                                <b-button  title = "Selecionar Item" size="sm" variant="outline-secondary" @click="setItem(data.item, showTable = !showTable)" class="mr-2 mt-2">
                                    <i class="fa fa-check-square-o"></i>
                                </b-button>
                            </template>   
                    </b-table>    
                    </transition>
         </b-modal>
         <b-modal id="modalTypeRleaseCompany"
            ref="modal"
            title="Classificação"
            title-tag = "h6"
            size="lg"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveApportionment"
            >
                <b-form>
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Custo:" 
                                label-for="typerelease-type_cost_id">
                            <b-form-select 
                                id="typerelease-type_cost_id"
                                size="sm"
                                :options="typecosts" 
                                v-model="typereleasesapportionment.type_cost_id" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">    
                    <b-form-group 
                        label="%:" 
                        label-for="typereleasesapportionment-percent">
                        <b-form-input 
                            id="typereleasesapportionment-percent" 
                            v-model="typereleasesapportionment.percent" 
                            type="number"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                    </b-form-group>
                </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group 
                                label="Centro de Custo/Receita:" 
                                label-for="typereleasesapportionment-cost_center_id">
                            <b-form-select 
                                id="typereleasesapportionment-cost_center_id"
                                size="sm"
                                :options="costcenters" 
                                v-model="typereleasesapportionment.cost_center_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="1º Nível:" 
                        label-for="typerelease-operation_level_one_id">
                    <b-form-select 
                        id="typerelease-operation_level_one_id"
                        @input="loadOperationsLevelTwos"
                        size="sm"
                        :options="operationslevelones" 
                        v-model="typereleasesapportionment.operation_level_one_id" />
                    </b-form-group>
                </b-col>
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="2º Nível:" 
                        label-for="typerelease-operation_level_two_id">
                    <b-form-select 
                        id="typerelease-operation_level_two_id"
                        size="sm"
                        :options="operationsleveltwos" 
                        v-model="typereleasesapportionment.operation_level_two_id" />
                    </b-form-group>
                </b-col>
            </b-row>
 
                </b-form>
            </b-modal>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'

export default {
      name: 'RecordTypeRelease',
      components: {PageTitle },
      data: function() {
          return {
                modeRetention: 'insert',
                modeTax: 'insert',
                modeItem: 'insert',
                modeCompany: 'insert',
                typerelease: {},
                typereleasesretention: {},
                typereleasesretentions:[],
                typereleasestax: {},
                typereleasestaxs:[],
                typereleasesitem: {},
                typereleasesitems:[],
                typereleasesapportionment: {},
                typereleasesapportionments:[],
                operationsleveltwos: [],
                operationslevelones: [],
                retentions: [],
                taxs: [],
                item:{},
                items: [],
                companys: [],
                costcenters: [],
                typecosts: [],
                showTable: false,
                search: '',
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fieldsRetention: [
                    { key: "name_retention", label: "Retenção", sortable:false },    
                    { key: "percent", label: "%", sortable:false }, 
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsTax: [
                    { key: "name_tax", label: "Imposto", sortable:false },    
                    { key: "percent", label: "%", sortable:false }, 
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsItem: [
                    { key: "complements_name", label: "Descrição", sortable:false },    
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsCompany: [
                    { key: "name_cost_center", label: "Centro de Custo/Receita", sortable:false },
                    { key: "name_type_cost", label: "Tipo de Custo/Receita", sortable:false },
                    { key: "name_operation_level_two", label: "Operação", sortable:false },    
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsRecordItem: [
                    { key: 'id', label: 'Código', sortable: true },
                    { key: 'complements_name', label: 'Nome', sortable: true },
                    { key: 'internal_code', label: 'Código Interno', sortable: false },
                    { key: 'stock', label: 'Estoque', sortable: false,
                            formatter: value => value ? 'Sim' : 'Não' },        
                    { key: 'blocked', label: 'Bloqueado', sortable: false,
                            formatter: value => value ? 'Sim' : 'Não' },               
                    { key: 'actions', label: 'Ações' }
            ]
          }
         
      },
       computed: {
            filteredList() {
             return this.items.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
         icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        }
        },
      methods:{ 
           loadTypeRelease() {
                const url = `${baseApiUrl}/typereleases/${this.typerelease.id}`
                    axios(url).then(res=> this.typerelease = res.data)
            },
            goback(){
                 this.$router.go(-1, {query: 'q=s', hash: 'hashFrag'})
            }, 
            loadItem() {
                const url = `${baseApiUrl}/items/${this.typereleasesitem.item_id}`
                            axios(url).then(res=> this.item = res.data)

            },
            setItem(item) {
                 this.typereleasesitem.item_id = item.id
                const url = `${baseApiUrl}/items/${this.typereleasesitem.item_id}`
                            axios(url).then(res=> this.item = res.data)

            },
            loadtItems(){
                const url = `${baseApiUrl}/items`
                axios(url).then(res =>{
                     this.items = res.data
                })
            },
            loadTypeReleasesRetention(typereleasesretention){
                this.typereleasesretention = { ...typereleasesretention }
            },
            loadTypeReleasesTax(typereleasestax){
                this.typereleasestax = { ...typereleasestax }
            },
            loadTypeReleasesItem(typereleasesitem){
                this.typereleasesitem = { ...typereleasesitem }
            },
            loadTypeReleasesApportionment(typereleasesapportionment){
                this.typereleasesapportionment = { ...typereleasesapportionment }
                this.loadCostCenter()
                this.loadOperationsLevelOnes()
                this.loadOperationsLevelTwos()
            },
            loadTypeReleasesRetentions(){
                const id = this.typerelease.id
                const url = `${baseApiUrl}/typereleasesretentions/${id}/typereleases`
                axios.get(url).then(res => {
                    this.typereleasesretentions = res.data
            })
           },
           loadTypeReleasesTaxs(){
                const id = this.typerelease.id
                const url = `${baseApiUrl}/typereleasestaxs/${id}/typereleases`
                axios.get(url).then(res => {
                    this.typereleasestaxs = res.data
            })
           },
            loadTypeReleasesItems(){
                const id = this.typerelease.id
                const url = `${baseApiUrl}/typereleasesitems/${id}/typereleases`
                axios.get(url).then(res => {
                    this.typereleasesitems = res.data
            })
           },
           loadTypeReleasesApportionments(){
                const id = this.typerelease.id
                const url = `${baseApiUrl}/typereleasesapportionments/${id}/typereleases`
                axios.get(url).then(res => {
                    this.typereleasesapportionments = res.data
            })
           },
           async saveRetention() {
                const method = this.typereleasesretention.id ? "put" : "post";
                const id = this.typereleasesretention.id ? `/${this.typereleasesretention.id}` : "";
                this.typereleasesretention.type_release_id = this.typerelease.id;
                await axios[method](`${baseApiUrl}/typereleasesretentions${id}`, this.typereleasesretention)
                    .then(() => {
                        this.$toasted.global.defaultSuccess();
                        this.typereleasesretention = {}
                        this.loadTypeReleasesRetentions();
                    })
                    .catch(showError)
            },
           async saveTax() {
                const method = this.typereleasestax.id ? "put" : "post";
                const id = this.typereleasestax.id ? `/${this.typereleasestax.id}` : "";
                this.typereleasestax.type_release_id = this.typerelease.id;
                await axios[method](`${baseApiUrl}/typereleasestaxs${id}`, this.typereleasestax)
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.typereleasestax = {}
                    this.loadTypeReleasesTaxs();
                    })
                    .catch(showError)
            },
            async saveItem() {
                const method = this.typereleasesitem.id ? "put" : "post";
                const id = this.typereleasesitem.id ? `/${this.typereleasesitem.id}` : "";
                this.typereleasesitem.type_release_id = this.typerelease.id;
                await axios[method](`${baseApiUrl}/typereleasesitems${id}`, this.typereleasesitem)
                .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.typereleasesitem = {}
                    this.loadTypeReleasesItems();
                })
                .catch(showError)
            },
             async saveApportionment() {
                const method = this.typereleasesapportionment.id ? "put" : "post";
                const id = this.typereleasesapportionment.id ? `/${this.typereleasesapportionment.id}` : "";
                this.typereleasesapportionment.type_release_id = this.typerelease.id;
                this.typereleasesapportionment.operation_id = this.typerelease.operation_type_id;
                await axios[method](`${baseApiUrl}/typereleasesapportionments${id}`, this.typereleasesapportionment)
                .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.loadTypeReleasesApportionments();
                })
                .catch(showError)
            },
            async RemoveRetention(typereleasesretention) {
                const id = typereleasesretention.id
                await  axios.delete(`${baseApiUrl}/typereleasesretentions/${id}`)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadTypeReleasesRetentions()
                    })
                    .catch(showError)
            },
            async RemoveTax(typereleasestax) {
                    const id = typereleasestax.id
                    await axios.delete(`${baseApiUrl}/typereleasestaxs/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTypeReleasesTaxs()
                        })
                        .catch(showError)
            },
            async RemoveItem(typereleasesitem) {
                    const id = typereleasesitem.id
                    await axios.delete(`${baseApiUrl}/typereleasesitems/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTypeReleasesItems()
                        })
                        .catch(showError)
            },
            async RemoveCompany(typereleasesapportionment) {
                    const id = typereleasesapportionment.id
                    await axios.delete(`${baseApiUrl}/typereleasesapportionments/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTypeReleasesApportionments()
                        })
                        .catch(showError)
            },
            loadRetention() {
                const url = `${baseApiUrl}/retentions`
                axios.get(url).then(res => {
                    this.retentions = res.data.map(retention => {
                        return { value: retention.id, text: retention.name_retention }
                        })
                    })
            },
            loadTax() {
                const url = `${baseApiUrl}/taxs`
                axios.get(url).then(res => {
                    this.taxs = res.data.map(tax => {
                        return { value: tax.id, text: tax.name_tax }
                        })
                    })
            },
            async loadCostCenter() {
                const url = `${baseApiUrl}/costcenteranalitic/${this.typerelease.company_id}`
                await axios.get(url).then(res => {
                    this.costcenters = res.data.map(costcenter => {
                        return { value: costcenter.id, text: costcenter.name_cost_center }
                        })
                    })
            },
            async loadOperationsLevelOnes() {
                const url = `${baseApiUrl}/operationslevelones/${this.typerelease.operation_type_id}/operations`
                await axios.get(url).then(res => {
                    this.operationslevelones = res.data.map(operationslevelone => {
                            return { value: operationslevelone.id, text: operationslevelone.name_operation_level_one }
                            })
                    })
            },
            async loadOperationsLevelTwos() {
                const url = `${baseApiUrl}/operationsleveltwos/${this.typereleasesapportionment.operation_level_one_id}/operationslevelones`
                await axios.get(url).then(res => {
                    this.operationsleveltwos = res.data.map(operationsleveltwo => {
                        return { value: operationsleveltwo.id, text: operationsleveltwo.name_operation_level_two }
                        })
                })
            },
             async loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            await axios.get(url).then(res => {
                   this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                    })
                })
            },
           
            alterModoItem(){
                this.typereleasesitem = {}
                this.item = {}
            },
            setAppointment(){
                this.typereleasesapportionment = {}
                this.loadCostCenter()
                this.loadOperationsLevelOnes()
            }    
      },
       watch:{
            $route(to){
                this.typerelease.id = to.params.id
            } 
        },
       async mounted(){
            this.typerelease.id = this.$route.params.id
          await  this.loadTypeRelease()
           
            this.loadTypeReleasesRetentions()
            this.loadTypeReleasesTaxs()
            this.loadTypeReleasesItems()
            this.loadTypeReleasesApportionments()
            this.loadRetention()
            this.loadTax()
            
            this.loadTypeCost()
            this.loadOperationsLevelOnes()

            
        }
}
</script>

<style>
     .record-typerelease select,label{
        font-size: 0.75rem;
    }
    .record-typerelease input{
        font-size: 0.75rem;
    }
     .record-typerelease button{
        font-size: 0.75rem;
    }

    #modalItem{
         font-size: 0.75rem;
    }

    #modalItem select{
         font-size: 0.75rem;
    }

    #modalItem button{
         font-size: 0.75rem;
    }

    #modalTax{
         font-size: 0.75rem;
    }

    #modalTax select{
         font-size: 0.75rem;
    }

    #modalTax button{
         font-size: 0.75rem;
    }

    #modalRetention{
         font-size: 0.75rem;
    }

    #modalRetention select{
         font-size: 0.75rem;
    }

    #modalRetention button{
         font-size: 0.75rem;
    }

    #modalTypeRleaseCompany{
         font-size: 0.75rem;
    }

    #modalTypeRleaseCompany select{
         font-size: 0.75rem;
    }

    #modalTypeRleaseCompany input{
         font-size: 0.75rem;
    }

    #modalTypeRleaseCompany button{
         font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }
</style>
